import { AxiosError } from 'axios'
import { useMutation, type UseMutationOptions } from 'react-query'

import agent from 'agent'
import useAuth from 'hooks/use-auth'
import { getEndpointWithParams } from 'queries/queries-utils'
import { statusChecksMutationKeys } from 'queries/status-checks/query-keys'
import { STATUS_CHECK_PAYLOAD_MAX_CONTENT_LENGTH } from 'queries/status-checks/query-utils'

import type { StatusCheckCreateRequest } from 'types/api/status-checks/status-check'

const axiosRequestConfig = {
  maxContentLength: STATUS_CHECK_PAYLOAD_MAX_CONTENT_LENGTH
}

function putStatusCheck(
  mutationKey?: ReturnType<typeof statusChecksMutationKeys.mutateStatusCheck>
) {
  return async (payload: StatusCheckCreateRequest) => {
    if (!mutationKey)
      throw new AxiosError(
        'Cannot udpate a status check without a status check ID'
      )

    const endpointWithParams = getEndpointWithParams(...mutationKey)
    const response = await agent.put<string>(
      endpointWithParams,
      payload,
      axiosRequestConfig
    )

    return response.data
  }
}

export function usePutStatusCheck(
  statusCheckId?: string,
  options?: Omit<
    UseMutationOptions<string, AxiosError, StatusCheckCreateRequest>,
    'mutationKey' | 'mutationFn'
  >
) {
  const { currentTeamId } = useAuth()
  const mutationKey = statusCheckId
    ? statusChecksMutationKeys.mutateStatusCheck({
        statusCheckId,
        teamId: currentTeamId
      })
    : undefined

  return useMutation({
    ...options,
    mutationKey,
    mutationFn: putStatusCheck(mutationKey)
  })
}
